(function() { module.exports = this["wp"]["domReady"]; }());